import { useContext, useEffect, createContext, useState, useRef } from "react";

import PropTypes from "prop-types";

import { ReadAloudContentModes } from "@/view/ReadAloudControls/useReadAloudMode/constants";

const ReadAloudContext = createContext();

const propTypes = {
  children: PropTypes.node,
};

export const ReadAloudContextProvider = ({ children }) => {
  const [isReadAloudModeActive, setIsReadAloudModeActive] = useState(false);
  const [readAloudContentMode, setReadAloudContentMode] = useState(
    ReadAloudContentModes.ARTICLE,
  );
  const [hasReadAloudInSession, setHasReadAloudInSession] = useState(false);
  const [currentSpeech, setCurrentSpeech] = useState(null);
  const readAloudSpanRefs = useRef({});
  const [currentMark, setCurrentMark] = useState({});

  useEffect(() => {
    // hasReadAloudInSession should remain true once it becomes true
    const value =
      hasReadAloudInSession ||
      (isReadAloudModeActive &&
        readAloudContentMode === ReadAloudContentModes.ARTICLE);

    setHasReadAloudInSession(value);
  }, [isReadAloudModeActive, readAloudContentMode]);

  return (
    <ReadAloudContext.Provider
      value={{
        isReadAloudModeActive,
        setIsReadAloudModeActive,
        readAloudContentMode,
        setReadAloudContentMode,
        currentSpeech,
        setCurrentSpeech,
        readAloudSpanRefs,
        hasReadAloudInSession,
        currentMark,
        setCurrentMark,
      }}
    >
      {children}
    </ReadAloudContext.Provider>
  );
};

ReadAloudContextProvider.propTypes = propTypes;

const useReadAloudMode = () => {
  const readAloudContext = useContext(ReadAloudContext);

  if (readAloudContext === undefined) {
    throw new Error(
      "useReadAloudMode must be used within a ReadAloudContextProvider.",
    );
  }

  return readAloudContext;
};

export default useReadAloudMode;
